import { ICommonSettingsModeleDocument, IHasETag, IList, IModeReception, INatureOperation, IQualiteTiers, ITiers, ITypeOperation, IUserLight, IUtilisateurParametre } from '@core';
import { CommonComportement, CommonEtat, DegreRisqueValeur, LibellePartie1, LibellePartie2 } from '@core-lib/enums';
import { ICompteLight } from './compte.model';

export interface INatureAffaire extends IHasETag {
	id: string;
	nom: string;
	code: string;
	libellePartie1: LibellePartie1;
	libellePartie2: LibellePartie2;
	partie2Obligatoire: boolean;
	piecesJointesObligatoires: INatureAffairePieceJointe[];
	degreRisque: IDegreRisque;

	// add for commentaire model
	actifAvocat: boolean;
	actifCarpa: boolean;
	degreRisqueId: string;
	additionalProperties: false;
}

export interface INatureAffairePieceJointe {
	id: string;
	nom: string;
	code: string;
	isCodeTechnique?: boolean;
	categorie: string;
}

export interface IDegreRisque {
	id: string;
	libelle: string;
	valeur: DegreRisqueValeur;
	verifier?: boolean;
}

export interface IStructureLight {
	id: string;
	raisonSociale: string;
	typeId: string;
	barreauId: string;
	adresse1: string;
	codePostal?: string;
	ville?: string;
	telephone?: string;
	email?: string;
	toque?: string;
	siren?: string;
	cnbf?: string;
	adresse2?: string;
	adresse3?: string;
	fax?: string;
	libelleCabinet?: string;
	isSupplee?: boolean;
	nomStructure?: string;
	isSignatureActive?: boolean;
	telephonePreference?: string;
	emailPreference?: string;
}

export enum TypesFacteurRisqueCodes {
	// C.5 ECR : Juridictions qui présentent des vulnérabilités
	JuridictionsAvecVulnerabilitesOperation = 'C5ECR_OP',
	JuridictionsAvecVulnerabilitesAffaire = 'C5ECR_AFF',
	// E.2 Identification d’un libellé à contrôle
	IdentificationLibelleAControleOperation = 'E2ILC_OP',
	IdentificationLibelleAControleAffaire = 'E2ILC_AFF',
	// F. Modification affaire
	ModificationNomAffaire = 'F1MNA_AFF',
	ModificationNatureAffaire = 'F2MNA_AFF',
	// E.3 Confrontation à l'api LCBFT
	ConfrontationApiLCBFT = 'E3CAL',
	OperationMontantMaxAssurance = 'B6OMMA',
	OperationNatureAffaireInhabituelle = 'B2ONI'
}
export interface IDocumentUploadResponse {
	data: any[];
	errors: string[];
}

export interface IReleveOperationsRequestDto {
	dateOperationDebut?: Date;
	dateOperationFin?: Date;
	avecEnteteCarpa?: boolean;
	affaireIds: string[];
	toutesAffaires?: boolean;
	filtresAffaires?: any;
}

export interface IAutorisationPrelevementRequestDto {
	affaireId: string;
}

export interface IAffaire extends IHasETag {
	id?: string;
	natureId: string;
	nature: INatureAffaire;
	nom?: string;
	numero: number;
	ancienNumero?: string;
	referenceCabinet?: string;
	partie1: ITiers[];
	partie2: ITiers[];
	estEnregistree: boolean;
	estArchivee: boolean;
	structure: IStructureLight;
	etat: CommonEtat;
	compte: ICompteLight;
	dateOuverture: string;
	soldeComptable: number;
	soldeBancaire: number;
	soldeDisponible: number;
	soldeSuffisant: number;
	ratioHonoraire: number;
	montantHonoraire: number;
	dateComportement?: string;
	utilisateurEtat: IUserLight;
	utilisateurComportement: IUserLight;
	degreRisque: IDegreRisque;
	comportement: CommonComportement;
	utilisateurAffecte: IUserLight;
	dateCreation: Date;
	utilisateurCreation: IUserLight;
	saisieFrontOffice?: boolean; // true si l'affaire est crée coté frontOffice
	montantCredits?: number; // somme des opérations au crédit dont le statut est à minima "Validé" (c'est-à-dire "Validé", "Généré', "Rapproché"...)
	montantDebits?: number; // somme des opérations au débit dont le statut est à minima "Validé" (c'est-à-dire "Validé", "Généré', "Rapproché"...)
	natureOperationCredits?: INatureOperation[];
	natureOperationDebits?: INatureOperation[];
}

export interface IAffaireViewModel {
	naturesAffaire?: INatureAffaire[];
	typesOperation?: ITypeOperation[];
	naturesOperation?: INatureOperation[];
	typesOperationCredit?: ITypeOperation[];
	typesOperationDebit?: ITypeOperation[];
	qualitesTiers?: IQualiteTiers[];
	qualitesTiersCredit?: IQualiteTiers[];
	qualitesTiersDebit?: IQualiteTiers[];
	modeReception?: IModeReception[];
	naturesOperationRetrait?: INatureOperation[];
	parametresUtilisateurs?: IUtilisateurParametre[];
	modelesRib?: ICommonSettingsModeleDocument[]
}

export interface ITransfertAffaireRequest {
	compteDestinationId: string;
	affairesIds: string[];
	filtresAffaires?: any;
}

export interface ITransfertOperationsRequest {
	operationIds: string[];
	affaireDestinationId: string;
}

export interface IUnarchiveAffairesRequest {
	affaireIds: string[];
	toutesAffaires?: boolean;
	filtresAffaires?: any;
}

export interface IArchiveAffairesRequest {
	affaireIds?: string[];
	filtresAffaires?: any;
}

export interface ISearchAffaireFilter {
	partie1?: string[];
	partie2?: string[];
	referenceCabinet?: string;
	numero?: number;
	compteId?: string;
	rechercheDoublon?: boolean;
	natureCode: string;
	pageNumber?: number;
	pageSize?: number;
	sortBy?: string;
}

export interface IAffairesList extends IList<IAffaire> {}
